module.exports = __webpack_public_path__ + "img/transfer-ownership.359a43c7.svg";